import React from 'react';
import { PageActions } from 'iovisit-theme/components/Views';
import config from '@plone/volto/registry';

const PageHeader = ({ content }) => {
  return (
    <div className="page-header">
      <h1 className="documentFirstHeading">{content.title}</h1>
      {content.show_share_links && (
        <PageActions
          content={content}
          showWhishlist={config.settings.showWishlistWidget}
        />
      )}
      <p className="documentDescription">{content.description}</p>
    </div>
  );
};
export default PageHeader;
